import { FileType } from '@/hooks/useFileLoading';
import { Moment } from 'moment';

export enum Situation {
  open = 'OPEN',
  liquidated = 'LIQUIDATED',
}

export enum FilterByDate {
  emissionDate = 'EmissionDate',
  dueDate = 'DueDate',
  payDate = 'PayDate',
}

export enum FilterExpensesBy {
  fixedExpenses = 'FIXED',
  variableExpenses = 'VARIABLE',
  withoutClassification = 'WITHOUTCLASSIFICATION',
}

export interface FinancialTrialBalanceForm {
  initialDate: Moment;
  finalDate: Moment;
  companiesIds: number[];
  dateFilterBy: FilterByDate;
  showPayablesAndReceivables: boolean;
  tariffs: boolean;
  showBankEntries: boolean;
  expenseFilterBy: FilterExpensesBy;
  planAccountIds: number[];
  situation: Situation;
}

export interface FinancialTrialBalance {
  companiesIds: string;
  startDate: string;
  endDate: string;
  isOpen: boolean;
  isSettled: boolean;
  dateFilterBy: FilterByDate;
  showPayablesAndReceivables: boolean;
  tariffs: boolean;
  showBankEntries: boolean;
  expenseFilterBy: string;
  planAccountIds: string;
  reportContentType: string;
}

//CASH-FLOW

export enum TypeReport {
  period = 'Period',
  weekly = 'Weekly',
  daily = 'Daily',
}

export interface FinancialCashFlowRequest {
  responseType: FileType;
  companiesIds: string;
  startDate: string;
  endDate?: string;
  isOpen: boolean;
  isSettled: boolean;
  typeReport: TypeReport;
  dateFilterBy: FilterByDate;
  showPayablesAndReceivables: boolean;
  showRate: boolean;
  showBankEntries: boolean;
  summary: boolean;
  bankAccountIds: string;
}

export interface FinancialCashFlowFormValues {
  companiesIds: number[];
  startDate: Moment;
  endDate: Moment;
  situation: Situation[];
  dateFilterBy: FilterByDate;
  typeReport: TypeReport;
  summary: boolean;
  showPayablesAndReceivables: boolean;
  showRate: boolean;
  showBankEntries: boolean;
  bankAccountIds: number[];
}
